<template>
  <div class="branches-view">
    <top-bar
      :title="branchName || 'Sucursal sin nombre'"
      :subtitle="branch.dealer.name"
      :show-add-button="$store.getters['profile/can']('evaluations.store')"
      add-button-label="Agregar evaluación"
      @addItem="onAddEvaluation"
    />
    <scrollable-container>
      <div class="inner-dashboard">
        <el-row class="row">
          <el-col :span="24">
            <div class="card animated fadeIn branches-score">
              <el-row>
                <el-col :span="16">
                  <h5>Calificación de la sucursal</h5>
                  <star-rating
                    class="branches-stars"
                    :score="branchScore.stars"
                  />
                </el-col>
                <el-col :span="8">
                  <div class="period-wrapper">
                    <el-form>
                      <el-form-item>
                        <el-select
                          v-model="currentPeriodId"
                          placeholder="Seleccione el periodo"
                          @change="onChangePeriod"
                        >
                          <el-option
                            v-for="period in periods"
                            :key="period.id"
                            :label="period.name"
                            :value="period.id"/>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row interactive"
        >
          <el-col :span="16">
            <div class="card animated zoomIn">
              <h5>Áreas Evaluadas</h5>
              <div class="divisions-wrapper">
                <div
                  class="division-item"
                  :span="8"
                  v-for="divisionScore of branchDivisionScores"
                  :key="divisionScore.id"
                >
                  <h6>{{ divisionScore.division }}</h6>
                  <star-rating :score="divisionScore.stars"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="card animated zoomIn branches-card">
              <h5>Evaluaciones</h5>
              <h1 class="text-center">{{ evaluationsPager.total }}</h1>
            </div>
          </el-col>
        </el-row>

        <ms-grid
          :data="evaluations"
          :columns="columns"
          :options="options"
          :pager="evaluationsPager"
        >
          <star-rating
            slot-scope="{row}"
            slot="stars"
            :score="row.stars"
          />
          <span
            slot-scope="{row}"
            slot="timeStatus"
            class="status"
            :class="row.timeStatus"
          >
            {{ row.timeStatus | status }}
          </span>
        </ms-grid>

      </div>
    </scrollable-container>
    <branch-evaluation-form
      :branch-id="branch.id"
      @closeModal="onCloseEvaluationForm"
      @onSave="onEvaluationAdded"
      v-if="showBranchEvaluationForm"
    />
  </div>
</template>

<script>
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'
import { ViewGuards } from '@/guards/branches.guards'
import statusFilter from '@/filters/status.filter'
import ElSelectDropdown from 'element-ui/packages/select/src/select-dropdown'
import moment from 'moment'
import BranchEvaluationForm from '@/modules/branches/branch-evaluation-form'
import http from '@/services/http.service'

export default {
  name: 'BranchesView',
  filters: {
    status: statusFilter
  },
  components: {
    BranchEvaluationForm,
    ElSelectDropdown,
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  data () {
    return {
      showBranchEvaluationForm: false,
      columns: [
        {
          label: 'Evaluación',
          property: 'layout.name',
          sortable: false,
          link: row => {
            if (this.canSolveEvaluation) {
              return { name: 'evaluation', params: { id: row.id } }
            } else if (row.status.completed) {
              return { name: 'evaluation-result', params: { id: row.id } }
            } else {
              return false
            }
          }
        },
        {
          label: 'Departamento',
          property: 'division'
        },
        {
          label: 'Periodo',
          property: 'period.name',
          sortable: false
        },
        {
          label: 'Estatus',
          property: 'status',
          filter: statusFilter,
          align: 'center'
        },
        {
          label: 'Tiempo',
          property: 'timeStatus',
          align: 'center'
        },
        {
          label: 'Inicio',
          property: 'startDate',
          type: 'date',
          align: 'center'
        },
        {
          label: 'Fin',
          property: 'endDate',
          type: 'date',
          align: 'center'
        },
        {
          label: 'Calificación',
          property: 'stars',
          align: 'center'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Consultar',
            icon: 'icon-eye',
            show: row => {
              return row.status === 'complete'
            },
            onClick: row => {
              this.$router.push({
                name: 'evaluation-viewer',
                params: { id: row.id }
              })
            }
          },
          {
            label: 'Resolver',
            icon: 'icon-edit',
            show: () => {
              return this.$store.getters['profile/can']('evaluations.update')
            },
            onClick: row => {
              if (row.timeStatus !== 'inactive') {
                this.$router.push({
                  name: 'evaluation',
                  params: { id: row.id }
                })
              } else {
                this.$alert(
                  'Esta evaluacion podrá ser resuelta hasta el ' +
                    moment(row.assignment.startDate).format('LL'),
                  'Evaluación programada'
                )
              }
            }
          },
          {
            label: 'Restaurar',
            icon: 'icon-edit',
            show: row => {
              return (
                row.status === 'complete' &&
                this.$store.getters['profile/can']('evaluations.update')
              )
            },
            onClick: row => {
              http.put('evaluations/reset/' + row.id).then(response => {
                this.$message.success(
                  'La evaluación se ha restaurado con éxito'
                )
                this.$store.dispatch('evaluations/query', {
                  'filters[where][branchId][eq]': this.$route.params.id,
                  with: 'assignment, branch, layout, period',
                  ...this.$route.query
                })
              })
            }
          },
          {
            label: 'Eliminar',
            icon: 'icon-trash',
            show: () => {
              return this.$store.getters['profile/can']('evaluations.destroy')
            },
            onClick: row => {
              this.$confirm('¿Está seguro que desea eliminar?')
            }
          }
        ]
      },
      filter: [
        {
          label: 'El día de Hoy',
          value: 1
        },
        {
          label: 'Útimos siete dias',
          value: 2
        },
        {
          label: 'Último mes',
          value: 3
        }
      ],
      branchDone: 2,
      branchLeft: 2,
      branchSuccess: 2,
      currentPeriodId: null
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    },
    canSolveEvaluation () {
      return this.$store.getters['profile/can']('evaluations.update')
    },
    ...mapGetters('evaluations', {
      evaluations: 'items',
      evaluationsPager: 'pagination'
    }),
    ...mapGetters('branches', {
      branch: 'item'
    }),
    ...mapGetters('periods', {
      periods: 'items'
    }),
    ...mapGetters('branchScores', {
      branchScores: 'items'
    }),
    ...mapGetters('branchDivisionScores', {
      branchDivisionScores: 'items'
    }),
    branchScore () {
      return this.branchScores[0] || {}
    },
    branchName () {
      if (this.branch.name) {
        return (
          this.branch.municipality +
          ', ' +
          this.branch.state +
          ' (' +
          this.branch.name +
          ')'
        )
      } else {
        return this.branch.municipality + ', ' + this.branch.state
      }
    }
  },
  mounted () {
    this.currentPeriodId = this.$store.getters['periods/currentId']
  },
  methods: {
    onCloseEvaluationForm () {
      this.showBranchEvaluationForm = false
    },
    onAddEvaluation () {
      this.showBranchEvaluationForm = true
    },
    onEvaluationAdded (model) {
      this.showBranchEvaluationForm = false
      this.currentPeriodId = model.periodId
      this.onChangePeriod()
    },
    onChangePeriod () {
      let loader = this.$loading()
      let promises = []
      promises.push(
        this.$store.dispatch('evaluations/query', {
          'filters[where][periodId][eq]': this.currentPeriodId,
          'filters[where][branchId][eq]': this.branch.id,
          with: 'assignment, branch, layout, period'
        })
      )
      promises.push(
        this.$store.dispatch('branchScores/query', {
          'filters[where][periodId][eq]': this.currentPeriodId,
          'filters[where][branchId][eq]': this.branch.id
        })
      )
      promises.push(
        this.$store.dispatch('branchDivisionScores/query', {
          'filters[where][periodId][eq]': this.currentPeriodId,
          'filters[where][branchId][eq]': this.branch.id
        })
      )
      Promise.all(promises)
        .then()
        .finally(() => {
          loader.close()
        })
    }
  },
  beforeRouteUpdate: ViewGuards.onUpdate,
  beforeRouteEnter: ViewGuards.onEnter
}
</script>

<style lang="scss">
.branches-view {
  .inner-dashboard {
    padding: 30px;
    .branches-score {
      padding: 30px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      h5 {
        @include font-primary(14px, semibold);
        color: #444444;
        margin-bottom: 10px;
        margin-top: 0;
      }
      .branches-stars {
        i {
          font-size: 18px;
          margin-right: 15px;
        }
      }
    }
  }

  .divisions-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    .division-item {
      width: 33%;
      min-width: 140px;
      display: flex;
      margin-top: 10px;
      h6 {
        width: 50%;
        text-align: right;
        margin-top: 0;
        margin-bottom: 20px;
      }
      .star-rating {
        width: 40%;
        margin-left: 20px;
      }
    }
  }

  .status {
    display: inline-block;
    background-color: dodgerblue;
    color: #ffffff;
    padding: 5px 10px;
    border-radius: 2px;
    &.inactive {
      background-color: #cdcdcd;
      color: #999999;
    }
    &.active {
      background-color: #0083ca;
    }
    &.on_time {
      background-color: #60a50a;
    }
    &.out_of_time {
      background-color: #da3300;
    }
  }
  .card {
    padding: 15px 20px;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: #fff;
    height: 100%;
    &.animated {
      animation-duration: 0.5s;
    }
    h5 {
      @include font-primary(14px, bold);
      color: #444444;
      margin-bottom: 0;
    }
    .branchers-card-options {
      width: 200px;
      input {
        @include font-primary(12px);
        color: #999999;
        border: none;
      }
    }
    h1 {
      @include font-primary(36px, light);
      color: $color-ui-primary;
    }
  }
  .interactive {
    .card {
      border-top: 1px solid rgba(221, 221, 221, 1);
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      height: 190px;
      &:hover {
        z-index: 100;
        background-color: rgba(248, 248, 248, 1);
        border: 1px solid rgba(204, 204, 204, 1);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      }
    }
    .el-col:nth-child(1) .card {
      animation-delay: 0.1s;
    }
    .el-col:nth-child(2) .card {
      animation-delay: 0.2s;
    }
    .el-col:nth-child(3) .card {
      animation-delay: 0.3s;
    }
    .el-col:nth-child(2) {
      .card {
        border-left: 1px solid rgba(221, 221, 221, 1);
        border-right: 1px solid rgba(221, 221, 221, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/branches/branches-view.vue